// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"97172b9a","447":"d2968f4f","590":"082eb2d9","813":"523c47ba","979":"84c5e447"}[chunkId] + ".chunk.css";
};